import Horn from "../components/pages/horn"

export default Horn
